import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "paging",
    attrs: {
      id: "paging"
    }
  }, [_c("div", {
    staticClass: "paging-line"
  }, [_vm.currentPage > 1 && _vm.currentPage <= _vm.numberOfPages ? _c("div", {
    staticClass: "arrows",
    on: {
      click: function click($event) {
        return _vm.changePage(1);
      }
    }
  }, [_c(VBtn, {
    staticClass: "dfwa-btn secondary square"
  }, [_vm._v("<<")])], 1) : _vm._e(), _vm.currentPage > 1 && _vm.currentPage <= _vm.numberOfPages ? _c("div", {
    staticClass: "arrows",
    on: {
      click: function click($event) {
        return _vm.changePage(_vm.currentPage - 1);
      }
    }
  }, [_c(VBtn, {
    staticClass: "dfwa-btn secondary square"
  }, [_vm._v("<")])], 1) : _vm._e(), _vm.currentPage >= _vm.minPageToOverflow && _vm.currentPage <= _vm.numberOfPages ? _c("div", {
    staticClass: "points"
  }, [_vm._v(" ... ")]) : _vm._e(), _vm._l(_vm.numberOfPages, function (n) {
    return [_vm.currentPage < _vm.minPageToOverflow && n < _vm.maxNumberDisplayed || _vm.currentPage >= _vm.minPageToOverflow && n >= _vm.currentPage - _vm.numberOfSideDisplay && n <= _vm.currentPage + _vm.numberOfSideDisplay ? _c("div", {
      key: n,
      staticClass: "paging-number-div",
      on: {
        click: function click($event) {
          return _vm.changePage(n);
        }
      }
    }, [n == _vm.currentPage ? _c("div", {
      staticClass: "currentPage paging-number"
    }, [_c(VBtn, {
      staticClass: "dfwa-btn highlight square",
      attrs: {
        disabled: ""
      }
    }, [_vm._v(" " + _vm._s(n) + " ")])], 1) : _c("div", {
      staticClass: "paging-number"
    }, [_c(VBtn, {
      staticClass: "dfwa-btn secondary square"
    }, [_vm._v(" " + _vm._s(n) + " ")])], 1)]) : _vm._e()];
  }), _vm.numberOfPages >= _vm.maxNumberDisplayed && _vm.currentPage < _vm.numberOfPages - _vm.numberOfSideDisplay && _vm.currentPage > 0 && _vm.currentPage < _vm.numberOfPages ? _c("div", {
    staticClass: "points"
  }, [_vm._v(" ... ")]) : _vm._e(), _vm.currentPage > 0 && _vm.currentPage < _vm.numberOfPages ? _c("div", {
    staticClass: "arrows",
    on: {
      click: function click($event) {
        return _vm.changePage(_vm.currentPage + 1);
      }
    }
  }, [_c(VBtn, {
    staticClass: "dfwa-btn secondary square"
  }, [_vm._v(">")])], 1) : _vm._e(), _vm.currentPage > 0 && _vm.currentPage < _vm.numberOfPages ? _c("div", {
    staticClass: "arrows",
    on: {
      click: function click($event) {
        return _vm.changePage(_vm.numberOfPages);
      }
    }
  }, [_c(VBtn, {
    staticClass: "dfwa-btn secondary square"
  }, [_vm._v(">>")])], 1) : _vm._e()], 2), _vm.directPages.length > 1 ? _c("div", {
    staticClass: "page_selector"
  }, [_vm._v(" Go to page : "), _c(VSelect, {
    attrs: {
      items: _vm.directPages,
      "hide-details": "auto"
    },
    on: {
      change: _vm.changePage
    },
    model: {
      value: _vm.directPage,
      callback: function callback($$v) {
        _vm.directPage = $$v;
      },
      expression: "directPage"
    }
  })], 1) : _vm._e()]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };